import React from 'react';

import { ReactComponent as FacebookIcon } from "../../../../../assets/img/homeV2Footer/facebook.svg";
import { ReactComponent as TwitterIcon } from "../../../../../assets/img/homeV2Footer/twitter.svg";
import { ReactComponent as LinkedInIcon } from "../../../../../assets/img/homeV2Footer/linkedin.svg";
import { ReactComponent as InstagramIcon } from "../../../../../assets/img/homeV2Footer/instagram.svg";
import { ReactComponent as YoutubeIcon } from "../../../../../assets/img/homeV2Footer/youtube.svg";
import { PageConstant } from '../../../../../constants';

export const talentPortalLinks = [
    { label: 'Jobs', page: PageConstant.JOB_PAGE },
    { label: 'Quizzes', page: PageConstant.MCQ_LIST },
    { label: 'Turing Profile', page: PageConstant.FINALIZE_RESUME }
]

export const resourcesLinks = [
    { label: 'How to get hired', page: 'https://www.turing.com/jobs' },
    { label: 'Developer reviews', page: 'https://www.turing.com/review' },
    { label: 'Talent resources', page: 'https://www.turing.com/kb' },
    { label: 'Tech interview questions', page: 'https://www.turing.com/sitemap/interview-questions' },
    { label: 'Blog', page: 'https://www.turing.com/blog' },
    { label: 'More resources', page: 'https://www.turing.com/resources' }
]

export const companyLinks = [
    { label: 'About', page: 'https://www.turing.com/company' },
    { label: 'Press', page: 'https://www.turing.com/press' },
    { label: 'Turing careers', page: 'https://careers.turing.com/' }
]

export const connectLinks = [
    { label: 'Contact us', page: 'https://www.turing.com/contact-us' },
    { label: 'Help center', page: 'https://help.turing.com/' }
]

export const sitemapLinks = [
    { label: 'Sitemap', page: 'https://www.turing.com/sitemap' },
    { label: 'Terms of service', page: 'https://www.turing.com/terms-of-service' },
    { label: 'Privacy policy', page: 'https://www.turing.com/policy' },
]

export const socialLinks = [
    { icon: <FacebookIcon />, url: 'https://www.facebook.com/turingcom' },
    { icon: <TwitterIcon />, url: 'https://x.com/turingcom', style: { marginTop: '10px' } },
    { icon: <LinkedInIcon />, url: 'https://www.linkedin.com/company/turingcom' },
    { icon: <InstagramIcon />, url: 'https://www.instagram.com/turingcom/#' },
    { icon: <YoutubeIcon />, url: 'https://www.youtube.com/@Turingcom/videos' },
]